import { isNumber, has } from 'underscore';

enum ScaleUnit
{
    Billion=1e9,
    Million=1e6,
    Thousand=1e3,
    None=1,
}

const getValueWithUnit = (value: number, unit: string) => {
  if (isNumber(value) && has(ScaleUnit, unit)) {
    return value * ScaleUnit[unit];
  }
  return 0;
};

const unitValueMap = {
  None: {
    value: 1,
    unit: '',
  },
  Thousand: {
    value: 1000,
    unit: 'K',
  },
  Million: {
    value: 1000000,
    unit: 'M',
  },
  Billion: {
    value: 1000000000,
    unit: 'B',
  },
};

export { unitValueMap, getValueWithUnit };
